import { render, staticRenderFns } from "./ActiveApplicant.vue?vue&type=template&id=0c8b70b2&lang=html&"
import script from "./ActiveApplicant.vue?vue&type=script&lang=js&"
export * from "./ActiveApplicant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports